import { render, staticRenderFns } from "./TAppraisalScorecard.vue?vue&type=template&id=561686d8&scoped=true"
import script from "./TAppraisalScorecard.vue?vue&type=script&lang=js"
export * from "./TAppraisalScorecard.vue?vue&type=script&lang=js"
import style0 from "./TAppraisalScorecard.vue?vue&type=style&index=0&id=561686d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561686d8",
  null
  
)

export default component.exports